import Base from './base'

export default class Notes extends Base {
  add(params: object) {
    return this.apiClient.post('notes', params)
  }
  list(id: string, params: object) {
    return this.apiClient.get(`notes/${id}`, params)
  }
  count(id: string, params: object) {
    return this.apiClient.get(`notes/${id}/count`, params)
  }
  markRead(noteIds: string[], params: object) {
    return this.apiClient.post('notes/read', { noteIds, ...params })
  }
  delete(id: string, params?: object) {
    return this.apiClient.delete(`notes/${id}`, params)
  }
  update(id: string, params: object) {
    return this.apiClient.put(`notes/${id}`, params)
  }

  arcProgress(id: string) {
    return this.apiClient.get(`notes/${id}/arc-progress`)
  }
}
